/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/member-ordering */
import { CM_ENV } from './config-manager-constants';

export default class ConfigManager {
    /**
     * 开关系统模块id
     * @type {string}
     * @memberof ConfigManager
     */
    public toggleModuleId;

    // 环境常量
    public static DEV: CM_ENV = CM_ENV.DEV;
    public static FORMAL: CM_ENV = CM_ENV.RELEASE;

    public static instance;
    public static getInstance(): ConfigManager {
        if (!ConfigManager.instance) {
            ConfigManager.instance = new ConfigManager();
        }
        return ConfigManager.instance;
    }
}
